export const BANNER_UPLOAD_REQUEST = "BANNER_UPLOAD_REQUEST";
export const BANNER_UPLOAD_SUCCESS = "BANNER_UPLOAD_SUCCESS";
export const BANNER_UPLOAD_FAIL = "BANNER_UPLOAD_FAIL";

export const BANNER_DELETE_REQUEST = "BANNER_DELETE_REQUEST";
export const BANNER_DELETE_SUCCESS = "BANNER_DELETE_SUCCESS";
export const BANNER_DELETE_FAIL = "BANNER_DELETE_FAIL";

export const ALL_SMALL_BANNER_VIEW_REQUEST = "ALL_SMALL_BANNER_VIEW_REQUEST";
export const ALL_SMALL_BANNER_VIEW_SUCCESS = "ALL_SMALL_BANNER_VIEW_SUCCESS";
export const ALL_SMALL_BANNER_VIEW_FAIL = "ALL_SMALL_BANNER_VIEW_FAIL";

export const BANNER_VIEW_REQUEST = "BANNER_VIEW_REQUEST";
export const BANNER_VIEW_SUCCESS = "BANNER_VIEW_SUCCESS";
export const BANNER_VIEW_FAIL = "BANNER_VIEW_FAIL";

export const SMALL_BANNER_UPLOAD_REQUEST = "SMALL_BANNER_UPLOAD_REQUEST";
export const SMALL_BANNER_UPLOAD_SUCCESS = "SMALL_BANNER_UPLOAD_SUCCESS";
export const SMALL_BANNER_UPLOAD_FAIL = "SMALL_BANNER_UPLOAD_FAIL";
export const SMALL_BANNER_VIEW_REQUEST = "SMALL_BANNER_VIEW_REQUEST";
export const SMALL_BANNER_VIEW_SUCCESS = "SMALL_BANNER_VIEW_SUCCESS";
export const SMALL_BANNER_VIEW_FAIL = "SMALL_BANNER_VIEW_FAIL";
export const SMALL_BANNER_DELETE_REQUEST = "SMALL_BANNER_DELETE_REQUEST";
export const SMALL_BANNER_DELETE_SUCCESS = "SMALL_BANNER_DELETE_SUCCESS";
export const SMALL_BANNER_DELETE_FAIL = "SMALL_BANNER_DELETE_FAIL";
